var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 496.158 496.158",
    style: {
      enableBackground: "new 0 0 496.158 496.158"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#334D5C"
    },
    d: "M248.082,0.003C111.07,0.003,0,111.063,0,248.085c0,137.001,111.07,248.07,248.082,248.07 c137.006,0,248.076-111.069,248.076-248.07C496.158,111.062,385.088,0.003,248.082,0.003z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2C900"
    },
    d: "M322.377,80.781c10.1,22.706,15.721,47.844,15.721,74.298c0,101.079-81.94,183.019-183.019,183.019 c-26.454,0-51.591-5.622-74.298-15.721c28.49,64.053,92.674,108.721,167.298,108.721c101.078,0,183.019-81.94,183.019-183.019 C431.098,173.454,386.43,109.27,322.377,80.781z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBBB00"
    },
    d: "M155.079,338.098c-26.454,0-51.591-5.622-74.298-15.721 c28.49,64.053,92.674,108.721,167.298,108.721c101.078,0,183.019-81.94,183.019-183.019 C431.098,248.079,256.157,338.098,155.079,338.098z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#DBBB00"
    },
    points: "236.634,188.671 209.692,187.721 201.228,162.948 192.765,187.721 165.823,188.671  187.533,203.82 179.347,230.293 201.228,213.77 223.109,230.293 214.924,203.82  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F2C900"
    },
    points: "209.824,194.758 214.465,177.15 199.799,187.941 183.881,178.107 190.219,195.371  175.339,207.49 194.323,206.778 200.644,224.693 206.441,206.399 224.826,205.941 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#DBBB00"
    },
    points: "101.521,229.699 82.134,229.015 76.043,211.187 69.952,229.015 50.564,229.699 66.187,240.6  60.296,259.651 76.043,247.761 91.789,259.651 85.898,240.6 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F2C900"
    },
    points: "82.228,234.079 85.568,221.408 75.014,229.174 63.558,222.096 68.12,234.52 57.412,243.241  71.074,242.729 75.623,255.621 79.795,242.456 93.024,242.127 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#DBBB00"
    },
    points: "278.639,68.596 255.368,67.775 248.058,46.377 240.747,67.775 217.476,68.596  236.228,81.682 229.156,104.548 248.058,90.276 266.958,104.548 259.887,81.682 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F2C900"
    },
    points: "255.482,73.853 259.491,58.644 246.822,67.966 233.072,59.471 238.549,74.382 225.694,84.85  242.093,84.236 247.554,99.71 252.561,83.909 268.44,83.513 "
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoonIcon);
export default __webpack_public_path__ + "static/media/moon-icon.0c8fc88f1b54da3c0a91cd252fa4026f.svg";
export { ForwardRef as ReactComponent };